import api from './api';

/**
 * DAU/WAU/MAU analytics (admin only).
 * Requires permission e.g. analytics_admin:analytics_active_users_summary GET.
 */

export const getActiveUsersSummary = async (params = {}) => {
  const response = await api.get('/admin/analytics/active-users/summary/', { params });
  return response.data;
};

export const getActiveUsersTimeseries = async (params = {}) => {
  const response = await api.get('/admin/analytics/active-users/timeseries/', { params });
  return response.data;
};

export const getActiveUsersByRegion = async (params = {}) => {
  const response = await api.get('/admin/analytics/active-users/by-region/', { params });
  return response.data;
};
